import React from "react";
import { ThemeProvider } from "styled-components";

import theme from "js/themes/theme";

import SiteFooter from "core/SiteFooter";

export const NounProjectFooter = () => {
    return (
        <ThemeProvider theme={theme}>
            <SiteFooter />
        </ThemeProvider>
    );
};

export default NounProjectFooter;
